import { render, staticRenderFns } from "./LanguageInputs.vue?vue&type=template&id=dd6c14f6&"
import script from "./LanguageInputs.vue?vue&type=script&lang=ts&"
export * from "./LanguageInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports